import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import SharedNotes from '../../../components/Share/SharedNotes';

const mapStateToProps = (state: StoreState) => {
	const { sharePanel: { selectedNotes } } = state;

	return { selectedNotes };
};

export default connect(mapStateToProps)(SharedNotes);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/SharedNotes/index.tsx